import { useState } from 'react';

import { Box, Button, Checkbox, Menu, MenuItem, Typography } from '@mui/material';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';

import { DROPDOWN_PAPER_SX, useActivityStyles } from './activityStyles';

// No request path (route) column: it carries internal record ids, which the firm view does not show.
export type ActivityColumn = 'matter' | 'entity' | 'record' | 'outcome';

export const OPTIONAL_COLUMNS: { key: ActivityColumn; label: string }[] = [
  { key: 'matter', label: 'Matter' },
  { key: 'entity', label: 'Entity' },
  { key: 'record', label: 'Record' },
  { key: 'outcome', label: 'Outcome' },
];

interface ActivityColumnsMenuProps {
  visible: ActivityColumn[];
  onChange: (visible: ActivityColumn[]) => void;
  onReset: () => void;
}

/** The optional columns only: Time, the person and Activity are always shown. */
const ActivityColumnsMenu = ({ visible, onChange, onReset }: ActivityColumnsMenuProps) => {
  const { classes } = useActivityStyles();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const toggle = (key: ActivityColumn) =>
    onChange(visible.includes(key) ? visible.filter((c) => c !== key) : [...visible, key]);

  return (
    <>
      <Button
        className={classes.toolbarButton}
        startIcon={<ViewColumnOutlinedIcon />}
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        Columns
      </Button>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        PaperProps={{ sx: DROPDOWN_PAPER_SX }}
      >
        <Box px="16px" py="4px">
          <Typography fontSize="13px" fontWeight={600}>
            Visible columns
          </Typography>
        </Box>
        {OPTIONAL_COLUMNS.map((column) => (
          <MenuItem key={column.key} dense onClick={() => toggle(column.key)}>
            <Checkbox size="small" checked={visible.includes(column.key)} />
            {column.label}
          </MenuItem>
        ))}
        <MenuItem
          dense
          onClick={() => {
            onReset();
            setAnchor(null);
          }}
        >
          Reset to default
        </MenuItem>
      </Menu>
    </>
  );
};

export default ActivityColumnsMenu;
